import Vue from 'vue'
import template from './index.vue'

const ImpeachConstructor = Vue.extend(template)

let impeachInstance = null
let lastConstructor = null
let lastOptions = null

//options必須帶有reportedId參數傳入被檢舉者Id 
const Impeach = (options = null) => {
  let Handler = ImpeachConstructor

  if (!impeachInstance || lastConstructor !== Handler || lastOptions && lastOptions.chatAvatar) {
    impeachInstance = new Handler({
      el: document.createElement('div')
    })
  }
  lastConstructor = Handler
  lastOptions = options
  Object.assign(impeachInstance.$data, options || {}, { visible: true })
  return new Promise(resolve => {
    impeachInstance.success = () => {
      resolve()
    }
    document.body.appendChild(impeachInstance.$el)
  })
}

export default Impeach